import { HTMLAttributes } from 'react'
import cl from 'classnames'

const InfoCardRoot = ({
  className,
  ...rest
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={cl(
        'flex flex-col gap-2 w-full justify-between bg-[#EFEFEF] rounded-lg pt-2 pb-1 px-2 shadow-[0_2.204px_2.204px_rgba(0,0,0,0.15)]',
        className
      )}
      {...rest}
    />
  )
}

export const Root = InfoCardRoot
